import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';
import { PaperCutIcon, type PaperCutIconName } from '@/components/icons/PaperCutIcon';

interface EmptyStateProps {
  icon?: LucideIcon;
  paperCutIcon?: PaperCutIconName;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionVariant?: 'default' | 'gradient' | 'outline';
  children?: React.ReactNode;
}

export function EmptyState({
  icon: Icon,
  paperCutIcon,
  title,
  description,
  actionLabel,
  onAction,
  actionVariant = 'default',
  children,
}: EmptyStateProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-16 px-6">
        {paperCutIcon ? (
          <PaperCutIcon name={paperCutIcon} size={96} className="mb-5" />
        ) : Icon ? (
          <div className="h-16 w-16 rounded-lg bg-secondary flex items-center justify-center mb-5">
            <Icon className="h-8 w-8 text-primary" />
          </div>
        ) : null}
        <h3 className="text-lg font-semibold mb-1.5">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground text-center max-w-sm mb-5">
            {description}
          </p>
        )}
        {children}
        {actionLabel && onAction && (
          <Button onClick={onAction} variant={actionVariant} className="gap-2">
            {actionLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
